import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const getToday = () => new Date().toISOString().slice(0, 10);

export default function StudentIndAtt() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const deptId   = parseInt(localUser?.deptid,   10);
  const navigate = useNavigate();

  const [students,   setStudents]   = useState([]);
  const [filter,     setFilter]     = useState({ selectedDate: getToday(), StudentID: "" });
  const [report,     setReport]     = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");

  useEffect(() => {
    if (moduleId !== 5) return;
    fetch(`${API_ROOT}/api/students/leave-students?moduleId=${moduleId}&deptId=${deptId}`)
      .then(r => r.json())
      .then(data => Array.isArray(data) && setStudents(data))
      .catch(() => {});
  }, [moduleId, deptId]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFilter(prev => ({ ...prev, [name]: value }));
  };

  const onView = async (e) => {
    e.preventDefault();
    if (!filter.StudentID) { alert("Please select a Student."); return; }
    setError(""); setReport(null); setLoading(true);
    try {
      const params = new URLSearchParams({
        moduleId,
        selectedDate: filter.selectedDate,
        studentId:    filter.StudentID,
      });
      const res  = await fetch(`${API_ROOT}/api/students/ind-monthly-att?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load.");
      setReport(data.data);
    } catch (err) {
      setError(err.message || "Failed to load attendance.");
    } finally {
      setLoading(false);
    }
  };

  if (moduleId !== 5) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Individual Monthly Attendance Register (Time With Leave)</h3>

      <div className="mb-3 d-flex flex-wrap gap-2">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate("/student-attendance")}>
          Monthly Attendance(Time With Leave)
        </button>
        <button type="button" className="btn btn-info btn-sm" onClick={() => navigate("/student-monthly-att-raw")}>
          Monthly Attendance(Raw)
        </button>
        <button type="button" className="btn btn-warning btn-sm" onClick={() => navigate("/student-upload-att")}>
          Upload Attendance
        </button>
        <button type="button" className="btn btn-success btn-sm" onClick={() => navigate("/student-monthly-att-leave")}>
          Monthly Attendance(With Leave)
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={onView}>
        <div className="row g-2 align-items-end mb-3">

          <div className="col-sm-2">
            <label className="form-label mb-1">Select Month Date</label>
            <input
              className="form-control"
              type="date"
              name="selectedDate"
              value={filter.selectedDate}
              onChange={onChange}
              required
            />
          </div>

          <div className="col-sm-4">
            <label className="form-label mb-1">Student</label>
            <select
              className="form-select"
              name="StudentID"
              value={filter.StudentID}
              onChange={onChange}
            >
              <option value="">Select Student</option>
              {students.map(s => (
                <option key={s.StudentID} value={s.StudentID}>
                  {s.StudentName}-{s.RollNo}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">View</label>
            <button type="submit" className="btn btn-primary form-control" disabled={loading}>
              {loading ? "Loading..." : "View"}
            </button>
          </div>

        </div>
      </form>

      {report && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-sm" style={{ fontSize: "13px", maxWidth: 600 }}>
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th colSpan={4}>
                  Monthly Attendance Report of {report.monthName} - {report.year}
                </th>
              </tr>
              <tr>
                <th>Date</th>
                <th>Time In</th>
                <th>Time Out</th>
                <th>Leave/Holiday</th>
              </tr>
            </thead>
            <tbody>
              {report.days.map((day, idx) => (
                <tr key={idx}>
                  <td style={{ whiteSpace: "nowrap" }}>{day.date}</td>
                  <td style={{ color: "black" }}>{day.timeIn}</td>
                  <td style={{ color: "black" }}>{day.timeOut}</td>
                  <td>
                    {day.timeStatus  && <span style={{ color: day.timeColor  }}>{day.timeStatus}</span>}
                    {day.leaveStatus && <span style={{ color: day.leaveColor }}>{day.timeStatus ? " " : ""}{day.leaveStatus}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
